<template>
    <svg
        height="24px"
        width="24px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke-width="1"
        id="notification-bell"
    >
        <path
            stroke="#000"
            d="M12.29 3.398a5 5 0 00-5 5v2c0 .758-.441 1.505-1.005 2.012a3 3 0 002.005 5.232h8a3 3 0 002.006-5.232c-.564-.507-1.005-1.254-1.005-2.012v-2a5 5 0 00-5-5z"
        />
        <path
            stroke="#F9B12A"
            stroke-linecap="round"
            d="M14.68 20.312l-.042.01a9.713 9.713 0 01-4.67-.01"
        />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-bell",
});
</script>

<style>
@keyframes notify {
    0%,
    to {
        transform: rotate(0deg);
        transform-origin: top center;
    }
    10%,
    90% {
        transform: rotate(2deg);
    }
    20%,
    40%,
    60% {
        transform: rotate(-6deg);
    }
    30%,
    50%,
    70% {
        transform: rotate(6deg);
    }
    80% {
        transform: rotate(-2deg);
    }
}
</style>
